// extracted by mini-css-extract-plugin
module.exports = {"aboutContainer":"about_aboutContainer__3ZGGN","backButton":"about_backButton__34fVW","fadeInToggle":"about_fadeInToggle__2QxQD","fadeOutToggle":"about_fadeOutToggle__-iOqO"};